import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_BATCH = 'LOAD_BATCH'
export const INATIVAR_SERVICOS = 'INATIVAR_SERVICOS'
export const RESET_STATE = 'RESET_STATE'
export const BOOTSTRAP_SERVICOS_RELATORIO = 'BOOTSTRAP_SERVICOS_RELATORIO'

const getDefaultState = () => {
  return {
    servicos: null,
    loading: true,
    listServicos: [],
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_BATCH] ({ commit, state }) {
    await api.listEntidade('servico').then(
      data => {
        const newServicos = data.map(({
          // fornecedor: { nome, nome_fantasia },
           ...rest
          }) => ({
          ...rest,
          // fornecedor: {
          //   nome: nome || nome_fantasia,
          // },
        }))
        commit(SET_STATE, { servicos: newServicos })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    commit(SET_STATE, { ready: false, loading: true })
    await dispatch(LOAD_BATCH)
    commit(SET_STATE, { ready: true, loading: false })
  },
  async [INATIVAR_SERVICOS] ({ dispatch, commit, state }, servico) {
    Swal.fire({
      title: 'Excluir',
      text: 'Tem certeza que deseja excluir o Serviço?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        return api.inativarEntidade('servico', servico.id).then(
            result => result,
            error => {
              Swal.fire({
                icon: 'error',
                title: 'Atenção!',
                text: error.message
                  ? error.message
                  : 'Não foi possivel excluir o Serviço!',
              })
            },
            // () => {
            //   window.Toast.fire('Ocorreu algum erro na exclusão do Serviço!', '', 'error')
            // },
          )
      },
    }).then(result => {
      if (result.isConfirmed) {
        window.Toast.fire('O Serviço foi excluído com sucesso!', '', 'success')
        dispatch(BOOTSTRAP)
      }
    })
  },
  async [BOOTSTRAP_SERVICOS_RELATORIO] ({ commit }) {
    await api.listEntidade('produto/filtroServico').then(
      response => {
        commit(SET_STATE, { listServicos: response })
      },
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
